import _Modules from '../core/core--modules';
import _bundle from '../core/core--bundles';
import {_g} from '../core/core--base';

const {_bp, _library} = _g;
const {_utils} = _library;

export default new _Modules({
    name: 'Collapsible',
    settings: {
        block: '.dropdown',
        elToggle: '.dropdown__toggle',
        elToggleRemote: '.dropdown__toggle-remote',
        matchElements: null, // match Function
        elContent: '.dropdown__content',
        elCloseClassName: 'dropdown__close',
        classOpen: 'open',
        classOpenLoad: '--open-onload',
        classCloseLoad: '--close-onload',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        breakpoint: null, // String for one, Array for Specific
        breakpointDir: null, // null is default which is down. Or 'up'
        callbackOpenAfter: null,
        callbackCloseAfter: null,
        callbackAfterFire: null,
        callbackBuilt() {
        },
        speed: false,
        disableSelector: '.--disable', // Classes on Toggle
        fireAs: 'bundle',
        debug: false
    },
    fn() {
        const _module = this;
        // Note: If using _module.settings, you get value from just one instance
        const {settings, name} = _module;

        settings.blockName = settings.block.split('.').join('');
        const {
            block,
            elToggle,
            elToggleRemote,
            matchElements,
            classOpen,
            classOpenLoad,
            classCloseLoad,
            closeOutside,
            closeAny,
            callbackAfterFire,
            callbackOpenAfter,
            callbackCloseAfter,
            callbackBuilt,
            closeButtonFn,
            speed,
            disableSelector,
            fireAs,
            debug
        } = settings;

        function _build($elToggle, callback) {
            const {$activeBlock, $activeToggle, $activeContent} = _matchElements($elToggle);
            $activeBlock.each(function (i, el) {
                const $block = $($activeBlock.get(i));
                const $toggle = $($activeToggle.get(i));
                const $content = $($activeContent.get(i));

                const idToggle = $toggle.checkIdAndSet();
                const idContent = $content.checkIdAndSet();

                $toggle.attr({
                    id: idToggle,
                    'aria-controls': idContent,
                    'aria-expanded': false,
                    'aria-selected': false,
                    'aria-hidden': true,
                    'data-cc-state': 'closed'
                });
                $content.attr({
                    id: idContent,
                    'aria-labelledby': idToggle,
                    'aria-hidden': true,
                    'data-cc-state': 'closed'
                });
                $block.attr({
                    'data-cc-state': 'closed'
                });
            });
            $activeToggle.filter(disableSelector).attr('disabled', true);
            if (typeof callback === 'function') callback();
        }

        const _buildOnce = _utils.once(function () {
            _build($(elToggle), callbackBuilt(settings));
        });

        // Find all block elements from toggle
        function _matchElements($elClicked) {
            // Specific from Instance
            if (matchElements) return matchElements($elClicked, settings);
            // Default
            return {
                $activeBlock: $elClicked.closest(block),
                $activeToggle: $elClicked,
                $activeContent: $elClicked.next()
            };
        }

        function _removeDefaults($elToggle) {
            const {$activeBlock, $activeToggle, $activeContent} = _matchElements($elToggle);
            const hasClass = $activeBlock.hasClass(classOpen);
            // const hasAttrs = $els.elToggle[0].hasAttribute('data-collapsible');

            if (hasClass) {
                $activeBlock.removeClass(classOpen);
                $activeToggle.removeClass(classOpen);
                $activeContent.removeClass(classOpen);
            }
            // If animation is used, undo inline CSS from it.
            if (speed) {
                if ($activeContent.css('display')) $activeContent.css('display', '');
            }
        }

        function _open($el) {
            const currentSet = _matchElements($el);
            const {$activeBlock, $activeToggle, $activeContent} = currentSet;
            $activeBlock.addClass(classOpen).attr({
                'data-cc-state': 'open'
            });
            $activeToggle.addClass(classOpen).attr({
                'aria-expanded': true,
                'aria-hidden': false,
                'aria-selected': true,
                'data-cc-state': 'open'
            });
            const $title = $activeToggle.find('.topic__title')
            if ($title.length > 0) {
                $title.addClass(classOpen).attr({
                    'aria-expanded': true,
                    'aria-hidden': false,
                    'aria-selected': true,
                    'data-cc-state': 'open'
                });
            }
            $activeContent.attr({
                'aria-hidden': false,
                'data-cc-state': 'open'
            });
            // Animate or toggle attributes
            if (speed) {
                $activeContent.slideDown(speed, function () {
                    $(this).addClass(classOpen);
                    if (callbackOpenAfter) callbackOpenAfter(settings, currentSet);
                });
            } else {
                $activeContent.addClass(classOpen);
                if (callbackOpenAfter) callbackOpenAfter(settings, currentSet);
            }

            if ($activeBlock.length || $activeToggle.length || $activeContent.length) {
                $el.trigger('collapsibleOpen');
            }
        }

        function _close($elToggle) {
            return new Promise(function (resolve, reject) {
                const hasClass = $elToggle.hasClass(classOpen);
                if (hasClass) {
                    const currentSet = _matchElements($elToggle);
                    const {$activeBlock, $activeToggle, $activeContent} = currentSet;
                    $activeBlock.removeClass(classOpen).attr({
                        'data-cc-state': 'closed'
                    });
                    $activeToggle.removeClass(classOpen).attr({
                        'aria-expanded': false,
                        'aria-hidden': true,
                        'aria-selected': false,
                        'data-cc-state': 'closed'
                    });
                    const $title = $activeToggle.find('.topic__title')
                    if ($title.length > 0) {
                        $title.removeClass(classOpen).attr({
                            'aria-expanded': false,
                            'aria-hidden': true,
                            'aria-selected': false,
                            'data-cc-state': 'closed'
                        });
                    }
                    $activeContent.attr({
                        'aria-hidden': true,
                        'data-cc-state': 'closed'
                    });
                    // Animate or toggle attributes
                    if (speed) {
                        $activeContent.slideUp(speed, function () {
                            $activeContent.removeClass(classOpen);
                            if (callbackCloseAfter) callbackCloseAfter(settings, currentSet);
                            resolve(settings, currentSet);
                        });
                    } else {
                        $activeContent.removeClass(classOpen);
                        if (callbackCloseAfter) callbackCloseAfter(settings, currentSet);
                        resolve(settings, currentSet);
                    }
                }
            });
        }

        // Check if an event handler is bound to an element
        function _hasBoundEvent($elChecking, eventType, handlerPassed) {
            const eventObject = $._data($elChecking.get(0), 'events');
            const eventBound = eventObject !== undefined;
            let handlersMatch;
            if (eventBound && eventObject[eventType] && eventObject[eventType][0].handler === handlerPassed) {
                handlersMatch = true;
            }
            const hasEventType = !!(eventObject && typeof eventObject[eventType] !== 'undefined');
            return eventBound && hasEventType && handlersMatch;
        }

        function _unbindEvents($elUnbind, eventType, handler) {
            // 1. Remove Handlers
            $elUnbind.each(function (index) {
                if (_hasBoundEvent($(this), eventType, handler)) {
                    $elUnbind.off(eventType, handler);
                    // 2. Remove Any Defaults
                    _removeDefaults($elUnbind);
                }
            });
        }

        function _openOnLoad($elToggle) {
            const $elOpen = $elToggle.filter(function () {
                return $(this).hasClass(classOpenLoad);
            });

            if ($elOpen.length) _open($elOpen);
        }

        function _closeOnLoad($elToggle) {
            const $elClosed = $elToggle.filter(function () {
                return $(this).hasClass(classCloseLoad);
            });

            if ($elClosed.length) _close($elClosed);
        }

        function _handleToggleClick(e) {
            const $this = $(this);
            // Multiple Collapsibles: Close all but current
            if (settings.closeOthers) {
                _close($(elToggle).not($this)).then(() => {
                    // console.log('The rest are closed');
                });
            }
            // Chekcking if module is open by container, so if on load an open class
            // is provided, we can trigger to open all elements
            const {$activeBlock} = _matchElements($this);

            if (!$activeBlock.hasClass(settings.classOpen)) {
                _open($this);
            } else {
                _close($this).then(() => {
                    // console.log('Current Closed');
                });
            }
        }

        function _bodyClick(e) {
            function closeExluding($elExcluded) {
                // Getting whole block click
                // =============================================================================
                // 1. Target of the click is the container.
                // 2. Target of the click is descendant of the container
                const blockTarget = $elExcluded.is(e.target); // 1.
                const blockChildrenTarget = $elExcluded.has(e.target).length > 0; // 2.

                // Identifing the Click Area
                const clickWithinExludedElement = (blockChildrenTarget || blockTarget) && true;

                if (!clickWithinExludedElement) _close($(elToggle));
            }

            if (closeOutside) closeExluding($(block));
            if (settings.closeAny) closeExluding($(elToggle));
        }

        function _bindEvents($elReceivesHandler, eventType, handler) {
            $elReceivesHandler.each(function (index) {
                // Prevent binding the event multiple times on resize
                if (!_hasBoundEvent($(this), eventType, handler)) {
                    $(this).on(eventType, handler);
                }
            });
        }

        // Fire Module
        // =============================================================================

        function _fire() {
            if ($(block).length) {
                const bpAll = settings.breakpoint === null;
                if (bpAll || _bp.match(settings.breakpoint, settings.breakpointDir)) {
                    _buildOnce();
                    _openOnLoad($(elToggle));
                    _closeOnLoad($(elToggle));
                    _bindEvents($(elToggle), 'click', _handleToggleClick);
                    _bindEvents($(document.body), 'click', _bodyClick);
                    if (callbackAfterFire) callbackAfterFire(_module);
                } else {
                    _unbindEvents($(elToggle), 'click', _handleToggleClick);
                    _unbindEvents($(document.body), 'click', _bodyClick);
                }
            }
        }

        if (fireAs === 'bundle') {
            _bundle.add({
                name: 'Module: Collapsible',
                event: ['on:BundleReady', 'on:ResizeEnd'],
                fn() {
                    _fire();
                }
            });
        }
        if (fireAs === 'async') _fire();

        return {
            getSettings() {
                return settings;
            },
            close(toggle) {
                return _close(toggle);
            },
            open(toggle) {
                return _open(toggle);
            }
        };
    }
});
